import React, { useContext } from 'react';
import {
    DoughnutChart,
    DoughnutChartSeriesItem,
} from 'utils/components/DoughnutChart/DoughnutChart';
import { NumberFormat } from '@instinet-analytics/core-lib';
import { getVenueTypeClass } from 'utils/venueTypeUtils';
import AppContext from 'app/AppContext';
import { OrderFillsCapsuleData } from '../useOrderFillsCapsuleData';
import classNames from 'classnames';

export interface OrderFillsCapsuleContentPieProps {
    data: OrderFillsCapsuleData;
}

export function OrderFillsCapsuleContentPie(
    props: OrderFillsCapsuleContentPieProps
) {
    const { numberFormat } = useContext(AppContext);
    const { data } = props;
    const chartData = toChartData(data, numberFormat);

    return (
        <div className="OrderFillsCapsuleContentPie">
            <DoughnutChart doughnutSize={90} data={chartData} />
        </div>
    );
}

function toChartData(
    data: OrderFillsCapsuleData,
    numberFormat: NumberFormat
): DoughnutChartSeriesItem[] {
    return data.orderData.map((d) => ({
        id: d.name,
        tooltip: {
            body: `${d.name} ${
                d.percent < 1
                    ? numberFormat.n1(d.percent)
                    : numberFormat.n0(d.percent)
            }%`,
        },
        value: d.barWidth,
        classname: classNames(
            getVenueTypeClass(d.venueTypeName ?? d.name),
            `v-${(d.micCode ?? d.name).replace(' ', '_')}`
        ),
        segmentWidth: 44,
    }));
}
